import ReactTooltip from 'react-tooltip';
import config from '../../../../../../application/config/config';
import './CustomListButton.css'
import { v4 as uuid } from "uuid";

function CustomListButton({ item, columnItem, onClickEdit, onClickView, onDelete, onCloneRegistry, list, showActionButtons, linkToDownload, data }) {
    const id = uuid();
    const downloadId = uuid();

    return (
        <>
            <div className="dropright">
                <button className={item.buttonClass} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px' }} type="button" id={id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {!item.icon && <span style={{
                        marginBottom: '10px',
                        textAlign: 'center'
                    }}>
                        {item.labelButton}
                    </span>}
                    {item.icon && <i className={item.icon} ></i>}
                </button>
                <div className="dropdown-menu" aria-labelledby={id} style={{ marginRight: '8px' }}>
                    {(list.canView && showActionButtons) && <div className="button-div dropdown-item" onClick={onClickView}>
                        <a
                            className="button-action"
                        >
                            <i className="fas fa-magnifying-glass mr-3"></i>
                            Visualizar
                        </a>
                    </div>}
                    {(list.canEdit && showActionButtons) && <div className="button-div dropdown-item" onClick={onClickEdit}>
                        <a
                            className="button-action"
                        >
                            <i className="fas fa-pencil-alt mr-3"></i>
                            Editar
                        </a>
                    </div>}
                    {(list.canDelete && showActionButtons) && <div className="button-div dropdown-item" onClick={onDelete}>
                        <a
                            className="button-action"
                        >
                            <i className="fas fa-trash mr-3"></i>
                            Excluir
                        </a>
                    </div>}
                    {(list.canDownload && linkToDownload && linkToDownload != "") && (
                            <a
                                className="button-div dropdown-item button-action"
                                target="_blank"
                                href={`${!linkToDownload.includes('http') ? config.endpoints.backend : ''}${linkToDownload}`}
                            >
                                <i className="fas fa-download mr-3"></i>
                                Baixar
                            </a>
                    )}
                    {(list.canDownload && (linkToDownload == "" || !linkToDownload)) && (
                        <>
                            <a
                                className="button-div dropdown-item button-action"
                                target="_blank"
                                data-tip data-for={"tooltip-notdownload-" + downloadId}
                                data-testid={`notdownload-${item[list.columns[0].name]}`}
                            >
                                <i className="fas fa-download mr-3"></i>
                                Baixar
                            </a>
                            <ReactTooltip id={"tooltip-notdownload-" + downloadId} place="top" effect="solid">
                                Sem arquivo
                            </ReactTooltip>
                        </>
                    )}
                    {item.showCloneButton && <div className="button-div dropdown-item" onClick={onCloneRegistry}>
                        <a
                            className="button-action"
                        >
                            <i className="fas fa-copy mr-3"></i>
                            Clonar Registro
                        </a>
                    </div>}
                    {item.buttons && item.buttons.map(button => {
                        let hideListButtonRule = false;
                        
                        if (button.hideListButtonRule) {
                            const result = button.hideListButtonRule(button, columnItem);
                            hideListButtonRule = result;
                        }

                        if (hideListButtonRule) {
                            return <></>;
                        }

                        return (

                        <div className="button-div dropdown-item" onClick={() => button.onClick(JSON.parse(data))}>
                            <a
                                className="button-action"
                            >
                                <i className={`${button.icon} ${button.label === '' ? 'mr-2' : 'mr-3'}`}></i>

                                {button.label}
                            </a>
                        </div>
                    )})}
                </div>
            </div>
        </>
    );
}
export default CustomListButton;